// extracted by mini-css-extract-plugin
module.exports = {"Root":"Box_Root__mlCVl","IsGray":"Box_IsGray__Irq0f","IsWhite":"Box_IsWhite__KvPcN"};